import type { SerialRow } from './cartTypes';
import { isCrossgradeProduct } from './cartLineKinds';

/** Matches backend `patchCartItem` cleanedRows: include rows with serial and/or host. */
export function rowHasSerialOrHost(row: SerialRow, item: any): boolean {
  const hasSerial =
    typeof row.serial === 'string' && row.serial.trim().length > 0;
  const isCrossgrade = isCrossgradeProduct(item.productId);
  const host = isCrossgrade ? row.targetHostApp : row.hostApp;
  const hasHost = Boolean(host?.id);
  return hasSerial || hasHost;
}

export function buildSerialMapPatchBody(
  rows: SerialRow[],
  item: any,
): {
  serial: string;
  hostApp?: any;
  sourceHostApp?: any;
  targetHostApp?: any;
}[] {
  const isCrossgrade = isCrossgradeProduct(item.productId);
  return rows
    .filter((r) => rowHasSerialOrHost(r, item))
    .map((r) => ({
      serial: typeof r.serial === 'string' ? r.serial.trim() : '',
      ...(isCrossgrade
        ? {
            sourceHostApp: r.sourceHostApp ?? null,
            targetHostApp: r.targetHostApp ?? null,
          }
        : {
            hostApp: r.hostApp ?? null,
          }),
    }));
}
